import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface PriceItem {
  work: string;
  price: string;
}
interface PriceCategoryCardProps {
  icon: BoxIcon;
  code: string;
  title: string;
  items: PriceItem[];
  index: number;
}
export function PriceCategoryCard({
  icon: Icon,
  code,
  title,
  items,
  index
}: PriceCategoryCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.06,
    ease: 'easeOut'
  }} className="group relative bg-neutral-900/50 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 p-6 flex flex-col" data-id="element-268">
      {/* Corner brackets */}
      <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-269" />
      <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-270" />
      <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-271" />
      <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-272" />

      {/* Header */}
      <div className="flex items-start gap-4 mb-5 pb-5 border-b border-white/10" data-id="element-273">
        <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-274">
          <Icon className="w-5 h-5 text-[#6B7A4A] transition-transform duration-200 group-hover:scale-110" data-id="element-275" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-276">
          <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-1" data-id="element-277">
            {code}
          </div>
          <h3 className="font-['Oswald'] text-lg font-semibold text-white uppercase tracking-wide leading-tight" data-id="element-278">
            {title}
          </h3>
        </div>
      </div>

      {/* Price list */}
      <ul className="space-y-3.5" data-id="element-279">
        {items.map((item, i) => <li key={i} className="flex items-baseline justify-between gap-4" data-id="element-280">
            <span className="text-sm text-zinc-300 font-['Inter'] leading-snug" data-id="element-281">
              {item.work}
            </span>
            <span className="flex items-baseline gap-1 shrink-0 whitespace-nowrap" data-id="element-282">
              <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 uppercase" data-id="element-283">
                від
              </span>
              <span className="font-['Oswald'] text-base font-bold text-[#A3E635] tracking-wide" data-id="element-284">
                {item.price}
              </span>
            </span>
          </li>)}
      </ul>
    </motion.div>;
}